module.exports = __webpack_public_path__ + "img/first_view_image_mobile_1.214ac362.png";